import { render, staticRenderFns } from "./ProfileParent.vue?vue&type=template&id=2f4b6d6a"
import script from "./ProfileParent.vue?vue&type=script&lang=js"
export * from "./ProfileParent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports